import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  // Öffentlich
  {
    path: 'welcome',
    loadComponent: () =>
      import('./features/welcome/welcome.component').then((m) => m.WelcomeComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/register/register.component').then((m) => m.RegisterComponent),
  },

  // Geschützt (authGuard)
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/url-list/url-list.component').then((m) => m.UrlListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'url/new',
    loadComponent: () =>
      import('./features/url-edit/url-edit.component').then((m) => m.UrlEditComponent),
    canActivate: [authGuard],
  },
  {
    path: 'url/edit/:shortPath',
    loadComponent: () =>
      import('./features/url-edit/url-edit.component').then((m) => m.UrlEditComponent),
    canActivate: [authGuard],
  },
  {
    path: 'debug',
    loadComponent: () =>
      import('./features/debug-console/debug-console.component').then(
        (m) => m.DebugConsoleComponent,
      ),
    canActivate: [authGuard],
  },

  // Admin (adminGuard)
  {
    path: 'admin/invite-codes',
    loadComponent: () =>
      import('./features/admin/invite-codes/invite-codes.component').then(
        (m) => m.InviteCodesComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'admin/telegram-users',
    loadComponent: () =>
      import('./features/admin/telegram-users/telegram-users.component').then(
        (m) => m.TelegramUsersComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'admin/telegram-bots',
    loadComponent: () =>
      import('./features/admin/telegram-bots/telegram-bots.component').then(
        (m) => m.TelegramBotsComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'admin/bot-tokens',
    loadComponent: () =>
      import('./features/admin/bot-tokens/bot-tokens.component').then(
        (m) => m.BotTokensComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'admin/codes',
    loadComponent: () =>
      import('./features/admin/codes/codes.component').then(
        (m) => m.CodesComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'admin/questionnaires',
    loadComponent: () =>
      import('./features/admin/questionnaires/questionnaire-list.component').then(
        (m) => m.QuestionnaireListComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'admin/questionnaires/new',
    loadComponent: () =>
      import('./features/admin/questionnaires/questionnaire-edit.component').then(
        (m) => m.QuestionnaireEditComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'admin/questionnaires/edit/:qId',
    loadComponent: () =>
      import('./features/admin/questionnaires/questionnaire-edit.component').then(
        (m) => m.QuestionnaireEditComponent,
      ),
    canActivate: [adminGuard],
  },

  // Redirects
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  { path: '**', redirectTo: 'welcome' },
];
